// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"274":"2c4697cd","3243":"aecce36d","7952":"3406b4d5","8125":"560df52c"}[chunkId] + ".chunk.css";
};